module.exports = __webpack_public_path__ + "static/ggbscert-c3f2587f6e4e4f721f982a9bcd59eacc.svg";